import { telegramClient } from 'better-auth-telegram/client'
import { createAuthClient } from 'better-auth/react'
import { env } from '~/env'

export const authClient = createAuthClient({
  baseURL: env.NEXT_PUBLIC_BETTER_AUTH_URL ?? '/api/auth',
  fetchOptions: {
    credentials: 'include', // Required for session-based operations
  },
  plugins: [telegramClient()],
})

export const {
  signIn,
  signOut,
  useSession,
} = authClient
